import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContextSpyId as selectContextSpyIdInState, 
    setContextSpyId as setContextSpyIdInState
} from 'store/applicationSlice'

export const useContextSpyId = () => {
    const dispatch = useAppDispatch()
    const contextSpyIdFromState = useAppSelector(selectContextSpyIdInState) 
    const selectContextSpyId = contextSpyIdFromState

    const setContextSpyId = (contextSpyId: any) => {
        dispatch(setContextSpyIdInState(contextSpyId))
    }
  
    return {
        selectContextSpyId,
        setContextSpyId
    }
}